import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import authSlice from "./reducer/auth/authSlice";
import navbarSlice from "./reducer/navbar/navbarSlice";
import paginationSlice from "./reducer/pagination/paginationSlice";
import promptSlice from "./reducer/prompt/promptSlice";
import activeTabSlice from "./reducer/activeTab/activeTabSlice";
import locationSlice from "./reducer/locationSlice/locationSlice";
import staticDataSlice from "./reducer/staticData/staticDataSlice";
import selectedAgentSlice from "./reducer/selectedAgent/selectedAgentSlice";
import filterSlice from "./reducer/filterSlice/filterSlice";
import salesRepMasterSlice from "./reducer/salesRepMaster/salesRepMasterSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  navbar: navbarSlice,
  pagination: paginationSlice,
  prompt: promptSlice,
  activeTab: activeTabSlice,
  locationState: locationSlice,
  staticData: staticDataSlice,
  selectedAgent: selectedAgentSlice,
  filter: filterSlice,
  salesRepMaster: salesRepMasterSlice,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["filter"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
